import React from 'react'

const AuthLoader = ({
  title = 'Population Explorer',
  message = 'Authenticating your session...'
}) => {
  return (
    <div className='auth-loader' role='status' aria-live='polite' aria-label={`${title} - ${message}`}>
      <div className='auth-loader__content'>
        <div className='auth-loader__wrapper'>
          <div className='auth-loader__ring' />
          <div className='auth-loader__ring auth-loader__ring--delay' />
          <svg
            viewBox='0 0 32 32'
            className='auth-loader__icon'
            xmlns='http://www.w3.org/2000/svg'
            aria-hidden='true'
          >
            <path
              fill='#000000'
              d='M15.7,32v-5.1c6.1,0,11.1-4.9,11.1-10.9c0-6-5-10.9-11.1-10.9V0C24.7,0,32,7.2,32,16C32,24.8,24.7,32,15.7,32z M24.8,16h-5.2c0-2.1-1.8-3.9-3.9-3.9s-3.9,1.7-3.9,3.9c0,2.1,1.8,3.9,3.9,3.9V25c-5,0-9.1-4-9.1-9c0-4.9,4.1-9,9.1-9 S24.8,11.1,24.8,16z'
            />
          </svg>
        </div>

        {title && <h2 className='auth-loader__title'>{title}</h2>}
        {message && <p className='auth-loader__message'>{message}</p>}

        <div className='auth-loader__progress-track' aria-hidden='true'>
          <div className='auth-loader__progress-bar' />
        </div>
      </div>
    </div>
  )
}

export default AuthLoader
